import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    TgDateTimeFormatterModule,
    TgGridModule,
    TgRackModule
} from '@trademe/tangram';
import { ListingDurationService } from '../../../services/listing-duration.service';
import { SummaryPageRentalDetailsSectionComponent } from './summary-page-rental-details-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgDateTimeFormatterModule,
        TgGridModule,
        TgRackModule
    ],
    declarations: [SummaryPageRentalDetailsSectionComponent],
    exports: [SummaryPageRentalDetailsSectionComponent],
    providers: [ListingDurationService]
})
export class SummaryPageRentalDetailsSectionModule {}
